<template>
  <div>
    <slot></slot>
  </div>
</template>

<script>
import {mapGetters, mapState} from 'vuex';
import TrekButton from '@/components/TrekButton';

export default {
  // eslint-disable-next-line vue/no-unused-components
  components: {TrekButton},

  props: {
    orderData: {
      type: Object,
      required: true,
      default: () => {},
    },
    textBikes: {
      type: String,
      default: '',
    },
    textAccessories: {
      type: String,
      default: '',
    },
    textAllocatedItems: {
      type: String,
      default: '',
    },
    textBackorderedItems: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      loading: true,
      tabs: [
        {
          id: 'tab-bikes',
          label: this.textBikes,
          key: 'bikes',
        },
        {
          id: 'tab-accessories',
          label: this.textAccessories,
          key: 'parts',
        },
      ],
      sections: [
        {
          id: 'backordered-allocated',
          label: this.textAllocatedItems,
          key: 'allocatedItems',
          qtyKey: 'allocatedItemsTotalQty',
        },
        {
          id: 'backordered-notAllocated',
          label: this.textBackorderedItems,
          key: 'notAllocatedItems',
          qtyKey: 'nonAllocatedItemsTotalQty',
        },
      ],
      orderType: '',
    };
  },

  provide() {
    return {
      container: this,
    };
  },

  computed: {
    ...mapState('backend', ['encodedContextPath']),
    ...mapGetters('backend', ['consumerFriendlyMode']),
  },
  created() {
    const urlParmas = new URLSearchParams(window.location.href);
    this.$set(this.orderData, 'orderType', urlParmas.get('ordertype'));
  },

  methods: {
    showSection(productType, sectionKey) {
      return this.orderData[productType].backordered[sectionKey].length;
    },

    sectionItems(productType, sectionKey) {
      return this.orderData[productType].backordered[sectionKey];
    },

    downloadOrderDetails() {
      window.location.href = `${this.encodedContextPath}/my-account/order/export/${this.orderData.orderNumber}?company=${this.orderData.orderCompany}&ordertype=${this.orderData.orderType}`;
    },

    isTabActive(tabKey) {
      const tabData = this.orderData[tabKey];
      let isActive = false;

      if (tabData.shipments.length || tabData.notShipped) {
        isActive = true;
      }
      for (const section of this.sections) {
        if (tabData.backordered[section.key].length) {
          isActive = true;
        }
      }
      return isActive;
    },
  },
};
</script>
